import React from "react";

const Death = ({ size = 50, color }: any) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 384"
      width={size}
      height={size}
    >
      <path
        fill="none"
        className="cls-1"
        d="M402,489.28H18v-384H402ZM258,303.71c-1.05-.06-1.65-.13-2.26-.13-24.88,0-49.75,0-74.63-.07-2.42,0-3.18,1-3.84,3-5,15.15-10.12,30.25-15.11,45.39-1.08,3.3-2.8,5.71-6.54,5.5-3.52-.2-5-2.61-5.81-5.85-3.9-15.85-7.9-31.67-11.88-47.5q-2.75-10.94-5.54-21.85a3.14,3.14,0,0,0-1.34,2c-3.63,14.37-7.31,28.74-10.85,43.13-.82,3.35-2.24,6-6,6.14s-5.41-2.38-6.56-5.57c-2.36-6.57-4.87-13.08-7.33-19.61-1.88-5-3.78-9.94-5.88-15.44a57.37,57.37,0,0,0-3.65,5.35c-2.16,4.16-5.38,5.79-10.09,5.46s-9.65-.07-14.5-.07v77.57H353.78V190H66.22V291.59c4.17,0,8,.21,11.9-.1a6.41,6.41,0,0,0,4.07-2.28c2.84-3.79,5.38-7.81,8-11.79,1.53-2.37,3.42-4.06,6.4-3.73s4.48,2.33,5.46,5c3,8.07,6,16.11,9,24.15.44,1.17,1,2.3,1.83,4.23,4.28-17.15,8.33-33.34,12.37-49.54,1.45-5.79,3.08-7.77,6.56-7.84s5.35,2,6.84,8q8.61,34.46,17.26,68.89a26.5,26.5,0,0,0,1.13,2.71c3.61-10.86,7-21,10.38-31.17,1.87-5.6,3.08-6.47,8.9-6.47h81.85c2.12-10.78,4.31-16,9-21.61,9.35-11.14,21.54-15.08,35.74-14.39,12.75.61,23.13,5.64,31,15.69,7.11,9.07,8.51,19.61,8.17,30.75-.37,11.84,1.07,10.82-9.76,16.21a5,5,0,0,0-2.21,3.6c-.3,3.72,0,7.48-.13,11.22-.12,4-2.33,6.39-6.27,6.41q-23.62.13-47.26,0c-4.16,0-6.32-2.38-6.44-6.62a32.94,32.94,0,0,1,0-6.36c.89-5.49-1.09-8.88-6.51-10.49-4.33-1.29-6.07-4.48-5.57-8.94A33.24,33.24,0,0,0,258,303.71ZM150,429.37c0-5.58,0-10.68,0-15.78,0-6.33,1.87-8.18,8.3-8.18H261.76c6.35,0,8.2,1.88,8.21,8.28,0,5.18,0,10.36,0,15.53h50c-8.89-3.38-13.93-9-13.94-17.81s5.06-14.43,13-18H62.36c-6.63,0-8.43-1.8-8.43-8.43q0-99.39,0-198.77c0-6.66,1.78-8.45,8.41-8.45H357.49c6.68,0,8.5,1.79,8.5,8.36V384.92c0,6.78-1.78,8.51-8.73,8.51H328.89c7.95,3.5,13,9.08,13,17.93s-5.07,14.44-13.08,17.8c13.71.21,27.2.22,40.7.21,6.56,0,8.47-1.92,8.47-8.46q0-123.36,0-246.7c0-6.52-1.91-8.41-8.51-8.41H50.33c-6.53,0-8.41,1.9-8.41,8.51V421c0,6.49,1.93,8.37,8.56,8.37H150ZM318,327.45c0-3.55.09-7.11,0-10.66-.12-3.38,1.1-6.17,4.35-7.05,7.07-1.91,8.82-6.57,7.67-13.11-.11-.61,0-1.25-.07-1.87-.69-8.39-3.15-16.13-10.3-21.16-11-7.71-23-8-34.9-2.64-10.95,5-14.12,14.85-14.86,26.15-.42,6.34.85,10.68,7.54,12.54,3.39.94,4.76,3.7,4.61,7.27s0,6.9,0,10.35h12.09V309.79h12.05v17.66Zm-60.19,90.2H162.25v11.53h95.54ZM318,411.32a6,6,0,1,0,6.05-5.88A6,6,0,0,0,318,411.32Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M258,303.71a33.24,33.24,0,0,1,0,3.36c-.5,4.46,1.24,7.65,5.57,8.94,5.42,1.61,7.4,5,6.51,10.49a32.94,32.94,0,0,0,0,6.36c.12,4.24,2.28,6.6,6.44,6.62q23.63.11,47.26,0c3.94,0,6.15-2.4,6.27-6.41.1-3.74-.17-7.5.13-11.22a5,5,0,0,1,2.21-3.6c10.83-5.39,9.39-4.37,9.76-16.21.34-11.14-1.06-21.68-8.17-30.75-7.86-10-18.24-15.08-31-15.69-14.2-.69-26.39,3.25-35.74,14.39-4.69,5.6-6.88,10.83-9,21.61H176.31c-5.82,0-7,.87-8.9,6.47-3.39,10.15-6.77,20.31-10.38,31.17a26.5,26.5,0,0,1-1.13-2.71q-8.64-34.44-17.26-68.89c-1.49-6-3.24-8-6.84-8s-5.11,2.05-6.56,7.84c-4,16.2-8.09,32.39-12.37,49.54-.84-1.93-1.39-3.06-1.83-4.23-3-8-6.07-16.08-9-24.15-1-2.65-2.5-4.66-5.46-5s-4.87,1.36-6.4,3.73c-2.57,4-5.11,8-8,11.79a6.41,6.41,0,0,1-4.07,2.28c-3.85.31-7.73.1-11.9.1V190H353.78V381.15H66.19V303.58c4.85,0,9.7-.27,14.5.07s7.93-1.3,10.09-5.46a57.37,57.37,0,0,1,3.65-5.35c2.1,5.5,4,10.47,5.88,15.44,2.46,6.53,5,13,7.33,19.61,1.15,3.19,2.81,5.74,6.56,5.57s5.15-2.79,6-6.14c3.54-14.39,7.22-28.76,10.85-43.13a3.14,3.14,0,0,1,1.34-2q2.77,10.94,5.54,21.85c4,15.83,8,31.65,11.88,47.5.79,3.24,2.29,5.65,5.81,5.85,3.74.21,5.46-2.2,6.54-5.5,5-15.14,10.12-30.24,15.11-45.39.66-2,1.42-3,3.84-3,24.88.11,49.75.07,74.63.07C256.32,303.58,256.92,303.65,258,303.71Zm83.7-78.1V202H294.16v11.76h36v11.84ZM90,213.56h29.66V202.05H78.15v23.39H90Zm180-.08H281.7V202.05H270.05Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M150,429.37H50.48c-6.63,0-8.56-1.88-8.56-8.37V174.31c0-6.61,1.88-8.51,8.41-8.51H369.48c6.6,0,8.51,1.89,8.51,8.41q0,123.35,0,246.7c0,6.54-1.91,8.46-8.47,8.46-13.5,0-27,0-40.7-.21,8-3.36,13.12-8.93,13.08-17.8s-5.06-14.43-13-17.93h28.37c6.95,0,8.73-1.73,8.73-8.51V186.14c0-6.57-1.82-8.36-8.5-8.36H62.34c-6.63,0-8.41,1.79-8.41,8.45q0,99.39,0,198.77c0,6.63,1.8,8.43,8.43,8.43H319.08c-8,3.55-13,9.1-13,18s5.05,14.43,13.94,17.81H270c0-5.17,0-10.35,0-15.53,0-6.4-1.86-8.27-8.21-8.28H158.25c-6.43,0-8.29,1.85-8.3,8.18C149.94,418.69,150,423.79,150,429.37Zm-84.2-12.12V405.62H54.17v11.63Zm24-11.54H78.13v11.45H89.8Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M318,327.45H306.11V309.79H294.06v17.48H282c0-3.45-.11-6.91,0-10.35s-1.22-6.33-4.61-7.27c-6.69-1.86-8-6.2-7.54-12.54.74-11.3,3.91-21.2,14.86-26.15,11.86-5.37,23.93-5.07,34.9,2.64,7.15,5,9.61,12.77,10.3,21.16,0,.62,0,1.26.07,1.87,1.15,6.54-.6,11.2-7.67,13.11-3.25.88-4.47,3.67-4.35,7.05C318.07,320.34,318,323.9,318,327.45Zm-35.81-41.68v11.59h11.54V285.77Zm35.62,11.66v-11.6H306.23v11.6Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M257.79,417.65v11.53H162.25V417.65Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M318,411.32a6,6,0,1,1,5.89,6A6,6,0,0,1,318,411.32Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        className="cls-1"
        d="M341.67,225.61H330.12V213.77h-36V202h47.51Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        className="cls-1"
        d="M90,213.56v11.88H78.15V202.05h41.52v11.51Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        className="cls-1"
        d="M270.05,213.48V202.05H281.7v11.43Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        className="cls-1"
        d="M65.75,417.25H54.17V405.62H65.75Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        className="cls-1"
        d="M89.8,405.71v11.45H78.13V405.71Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        className="cls-1"
        d="M282.17,285.77h11.54v11.59H282.17Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        className="cls-1"
        d="M317.79,297.43H306.23v-11.6h11.56Z"
        transform="translate(-18 -105.28)"
      />
    </svg>
  );
};

export default Death;
